import { LabelLangString } from "component/LabelLang/label-lang";
import { API_BASE_URL } from "configs/AppConfig";
import { TextSlicer } from "functions/textSlicer";
import { useSelector } from "react-redux";

const IndicatorCard = ({
  icon,
  translation,
  studyPeriod,
  title,
  unit,
  value,
}) => {
  const currentLocale = useSelector(({ theme }) => theme.locale);

  return (
    <div className="s-card">
      <div className="scard_head fw-bold">
        <h4 className="fw-bold">
          {Math.round((value + Number.EPSILON) * 10) / 10}
        </h4>
        <h6 className="fw-bold">
          {LabelLangString({
            id: "unit",
            currentLocale: currentLocale,
            defaultValue: unit,
            translations: translation,
          })}
        </h6>
      </div>
      <div className="scard_body">
        <img
          className="selectedIndicatorCardImg mx-auto"
          src={
            icon !== null && icon !== undefined
              ? `${API_BASE_URL}/${icon}`
              : process.env.PUBLIC_URL + "/image/up1.svg"
          }
          alt={LabelLangString({
            id: "title",
            currentLocale: currentLocale,
            defaultValue: title,
            translations: translation,
          })}
          loading="lazy"
        />
      </div>
      <div className="scard_foot">
        <h5>
          <TextSlicer
            txt={LabelLangString({
              id: "title",
              currentLocale: currentLocale,
              defaultValue: title,
              translations: translation,
            })}
            max={60}
          />
        </h5>
        <h6>
          (
          {LabelLangString({
            id: "studyPeriod",
            currentLocale: currentLocale,
            defaultValue: studyPeriod,
            translations: translation,
          })}
          )
        </h6>
      </div>
    </div>
  );
};

export default IndicatorCard;
